import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const popover: SxStyle = {
  mt: 5,
  '.MuiPaper-root': {
    width: (p) => p.spacing(23.5),
    borderColor: (p) => p.palette.primary[500],
    borderRadius: (p) => p.spacing(1),
    p: 0,
  },
};

export const item: SxStyle = {
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  p: (p) => p.spacing(1, 0.5),
  borderBottomColor: (p) => p.palette.grey[300],
  fontSize: (p) => p.typography.body4.fontSize,
  cursor: 'pointer',
  '&:last-child': {
    borderBottomWidth: 'none',
    borderBottomStyle: 'none',
    borderBottomColor: 'none',
  },
  '&:hover': {
    background: (p) => p.palette.primary[50],
  },
};

export const optionsPlaceholder: SxStyle = {
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  p: (p) => p.spacing(1, 0.5),
  borderBottomColor: (p) => p.palette.grey[300],
  fontSize: (p) => p.typography.body4.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
  color: (p) => p.palette.grey[400],
};

export const selected: SxStyleFunc<boolean | undefined> = (open) => ({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: open
    ? (p) => p.palette.primary[300]
    : (p) => p.palette.grey[300],
  boxShadow: open
    ? '0px 0px 0px 4px  rgba(112, 147, 245, 0.1)'
    : '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  borderRadius: (p) => p.spacing(1),
  fontSize: (p) => p.typography.body4.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
  padding: (p) => p.spacing(1),
  cursor: 'pointer',
  '&:hover': {
    borderColor: (p) => p.palette.primary[300],
    boxShadow: `0px 0px 0px 4px  rgba(112, 147, 245, 0.1)`,
  },
});
